// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {Fragment, useContext, useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
import etask from 'zetask';
import zdate from '/util/date.js';
import {Settings_context} from '../../settings_ctx';
// import Icon_check from '../../img/hola2023/icons/10/check.svg';
import Icon_chevron_left from '../../img/hola2023/icons/16/chevron_left.svg';
import Icon_chevron_right from '../../img/hola2023/icons/16/chevron_right.svg';
import Icon_x_close from '../../img/hola2023/icons/16/x_close.svg';
import Icon_rainbow from '../../img/hola2023/icons/24/rainbow.svg';
import Icon_glasses from '../../img/hola2023/icons/24/glasses.svg';
import Icon_bolt from '../../img/hola2023/icons/24/bolt.svg';
import Icon_tv from '../../img/hola2023/icons/24/tv.svg';
import Icon_cards from '../../img/hola2023/icons/24/cards.svg';
import Icon_wavy_check from '../../img/hola2023/icons/24/wavy_check.svg';
import Icon_mobile_button from '../../img/hola2023/icons/24/mobile_button.svg';
import Svg_surf from '../../img/cp/surf_bg.svg';
import Svg_visa from '../../img/visa.svg';
import Svg_amex from '../../img/amex.svg';
import Svg_mastercard from '../../img/mastercard.svg';
import Svg_jcb from '../../img/jcb.svg';
import Svg_discover from '../../img/discover.svg';
import Svg_unlimited from '../../img/cp/features/unlimited.svg';
import Svg_devices from '../../img/cp/features/devices.svg';
import Svg_more from '../../img/cp/features/more.svg';
import Svg_watch from '../../img/cp/features/watch.svg';
import Svg_speed from '../../img/cp/features/speed.svg';
import Svg_incognito from '../../img/cp/features/incognito.svg';
import Svg_cancel_start from '../../img/cp/cancel_start_bg.svg';
import Svg_cancel_done from '../../img/cp/cancel_done_bg.svg';
import Svg_appstore_modal from '../../img/cp/appstore_modal.svg';

import {t_use_cp} from './use_cp';
import {Button} from '../../../../shared/button';
import {use_translation_v} from '../../lib/trans_v';

// @ts-ignore
import {get_payment_history} from 'hola_pub_util';
import {Modal} from '../../../../shared/ui/modal';
import {Textarea} from '../../lib/textarea';
import styles from './cp_premium.module.less';

interface i_view_props
  extends Pick<t_use_cp, 'premium' | 'back_btn' | 'is_mobile'> {
    active?: boolean;
    toggle?: (to: string)=>void;
}

interface i_modal_header_props {
    on_back: () => void;
    on_close: () => void;
}

const format_plan = plan=>{
  if (plan.toLowerCase().includes('month'))
    return 'month';
  if (plan.toLowerCase().includes('year'))
    return 'year';
  return 'week';
};

// const Features_list = ()=>{
//     const {theme} = useContext(Settings_context);
//     const ic = <span className={styles.v}><Icon_check/></span>;
//     return <div className={styles.list}>
//       <p className={theme.p3}>{ic} <b>Unlimited</b> Hola watch time</p>
//       <p className={theme.p3}>{ic} Access any website you want</p>
//       <p className={theme.p3}>{ic} Use across multiple devices</p>
//       <p className={theme.p3}>{ic} Get access to content in HD</p>
//       <p className={theme.p3}>{ic} Use incognito mode</p>
//       <p className={theme.p3}>{ic} Use individual tabs</p>
//     </div>;
// };

interface i_features_grid_props {
    is_mobile: boolean;
}

const Cancel_features_grid = (props: i_features_grid_props)=>{
    const {is_mobile} = props;
    const {theme} = useContext(Settings_context);
    const breakEl = is_mobile ? <>&nbsp;</> : <br/>;
    const features = [
        {
            id: 'unlimited',
            icon: is_mobile ? <Icon_rainbow/> : <Svg_unlimited/>,
            text: <p className={cn(theme.p2, theme.med)}>
              <span>Unlimited</span> Limited
              {breakEl}watch time
            </p>,
        },
        {
            id: 'devices',
            icon: is_mobile ? <Icon_mobile_button/> : <Svg_devices/>,
            text: <p className={cn(theme.p2, theme.med)}>
              Use on <span>up
              {breakEl}to 10</span> 1 device
            </p>,
        },
        {
            id: 'more',
            icon: is_mobile ? <Icon_cards/> : <Svg_more/>,
            text: <p className={cn(theme.p2, theme.med)}>
              <span>Unlimited</span> Limited
              {breakEl}websites
            </p>,
        },
        {
            id: 'watch',
            icon: is_mobile ? <Icon_tv/> : <Svg_watch/>,
            text: <p className={cn(theme.p2, theme.med)}>
              <span>High video
              {breakEl}quality</span>
            </p>,
            disabled: true,
        },
        {
            id: 'speed',
            icon: is_mobile ? <Icon_bolt/> : <Svg_speed/>,
            text: <p className={cn(theme.p2, theme.med)}>
              <span>Optimized
              {breakEl}connection speed</span>
            </p>,
            disabled: true,
        },
        {
            id: 'incognito',
            icon: is_mobile ? <Icon_glasses/> : <Svg_incognito/>,
            text: <p className={cn(theme.p2, theme.med)}>
              <span>Open in
              {breakEl}incognito mode</span>
            </p>,
            disabled: true,
        },
    ];
    return <div className={styles.features_grid}>
      {features.map(({id, icon, text, disabled})=>{
          const cls = cn(styles.feature, disabled && styles.disabled);
          return <div key={id} className={cls}>{icon}{text}</div>;
      })}
    </div>;
};

const ic_right = <Icon_chevron_right/>;

const Modal_header = ({on_back, on_close}: i_modal_header_props)=>{
    return (
      <div className={styles.modal_header}>
        <button type="button" onClick={()=>on_back()}>
          <Icon_chevron_left/>
        </button>
        <button type="button" onClick={()=>on_close()}>
          <Icon_x_close />
        </button>
      </div>
    );
};

type t_history_item = {
  gateway: string;
  created_at: string;
  currency: string;
  period?: string;
  cc_type?: string;
  cc_digits?: string;
  amount: number;
  amount_usd?: number;
};

const get_payment_data = (t: t_history_item)=>{
  const date: string = zdate.strftime('%B %d, %Y', new Date(t.created_at));
  const is_card = t.cc_type && t.cc_digits;
  const method = is_card
      ? <span className={styles.cc}>
        {get_cc_icon(t.cc_type)} {t.cc_digits}
      </span> : get_payment_method(t.gateway);
  const amount = t.currency=='USD' ? `$${t.amount}` :
      `${t.amount} ${t.currency}`;
  let desc: string = period2desc[t.period] || 'Hola Premium';
  if (t.amount<1)
  {
    desc = period2sub_desc[t.period] || 'Hola Premium with 3 days trial';
    const d = new Date(t.created_at);
    return {date: zdate.strftime('%B %d, %Y',
      new Date(d.setDate(d.getDate() + 3))), amount,
      method, desc, timestamp: new Date(t.created_at).getTime()};
  }
  return {date, method, amount, desc,
      timestamp: new Date(t.created_at).getTime()};
};

type t_payment_item = ReturnType<typeof get_payment_data>;

const use_payment_history = ()=>{
  const [history, set_history] = useState<t_payment_item[]>([]);
  useEffect(()=>{
      if (history.length)
          return;
      etask(function*(){
        const data: t_history_item[] = yield get_payment_history();
        set_history(data.map(get_payment_data));
      });
  }, [history.length]);
  return history;
};

type t_plan_view_props = Pick<i_view_props,
  'premium' | 'back_btn' | 'is_mobile' | 'active' | 'toggle'>
  & { history: t_payment_item[]};

type t_modal_types = 'cancel_start' | 'cancel_features'
  | 'cancel_features_apple' | 'cancel_trial' | 'cancel_help'
  | 'cancel_done' | null;

const Plan_view = (props: t_plan_view_props)=>{
    const {premium, back_btn, is_mobile, active, toggle} = props;
    const {is_plus, header, plan, cancelled, cancel} = premium;
    const {theme} = useContext(Settings_context);
    const [modal, set_modal] = useState<t_modal_types>(null);
    const [reason, set_reason] = useState('');
    const [answer, set_answer] = useState<string | null>(null);
    const {t} = use_translation_v({version: 0});
    const amount = plan?.currency=='USD' ? `$${plan?.amount}` :
    `${plan?.amount} ${plan?.currency}`;
    const survey_data = t(`surveys.all.cancel_auto_renewal_survey`,
        {returnObjects: true});
    const question = survey_data.pages?.[0].questions[0];
    const get_on_select_answer =
      (next_answer: string | number)=>(e: React.MouseEvent)=>{
          e.preventDefault();
          set_answer('' + next_answer);
          set_modal('cancel_start');
      };
    useEffect(()=>{
        if (cancelled)
            set_modal(null);
    }, [cancelled]);
    const set_modal_cancel_features_by_gateway_type = ()=>{
      if (props.premium.plan.gateway)
      {
        props.premium.plan.gateway=='apple' ?
          set_modal('cancel_features_apple') : set_modal('cancel_features');
        return;
      }
      set_modal('cancel_features');
    };
    return <div className={cn(styles.content, styles.plan_view,
      active && styles.active)}>
      <h1 className={styles.title}>{back_btn}My plan</h1>
      <section className={styles.section}>
        <h2 className={styles.section_title}>My current plan</h2>
        {!!is_plus && !!cancelled && <div className={styles.canceled_msg}>
          <Icon_wavy_check width={24} height={24}/>
          <p className={theme.p3}>
            Your subscription was cancelled successfully,
            it will remain active until the end of your billing period
          </p>
        </div>}
        {!is_plus && <div className={cn(styles.line, styles.free_line)}>
          <p className={cn(theme.p2, theme.med)}>{header}</p>
          {/* <div className={styles.line_control}>
            <Button to="/premium?ref=cp" color="white" size="xs"
              caption="Manage plan" cls={styles.manage_plan} inline/>
          </div> */}
        </div>}
        <div className={cn(styles.features, {[styles.premium]: is_plus})}>
          {is_plus ? <div className={styles.premium_header}>
            <p className={cn(theme.p2, theme.bold)}>
              {header}
              {plan.trial && <Fragment>
                <br />
                <span className={cn(theme.p3,
                  theme.med)}>
                  free trial ends on {plan?.grace_end||plan?.next}</span>
                </Fragment>}
              </p>
          </div> : <Fragment>
            {!is_mobile && <Svg_surf className={styles.surf_bg}/>}
            {/* <h5 className={styles.free_title}>
              Access a <br/>Borderless Internet
            </h5> */}
          </Fragment>}
          {/* <Features_list/> */}
          {/* icon placeholder */}
          <div style={{minHeight: '280px'}}>
          </div>
          {/* {!is_plus && <Button to="/premium?ref=cp" color="black2023"
            size="md" caption="Upgrade to Premium" cls={styles.upgrade_btn}
            inline/>} */}
        </div>
      </section>
      {plan && <Fragment>
        <section className={styles.section}>
          <h2 className={styles.section_title}>Plan details</h2>
          <div className={cn(styles.line, styles.plan_details)}>
            <table>
              <tbody>
                <tr>
                  <td>Subscription</td>
                  <td>{plan.name}</td>
                  <td></td>
                </tr>
                <tr>
                  <td>Started on </td>
                  <td>{plan.start}</td>
                  <td></td>
                </tr>
                <tr>
                  <td>Payment history</td>
                  <td>
                    <span className={styles.link}
                      onClick={()=>{ toggle('history'); }}>
                      Show history
                    </span>
                  </td>
                  <td></td>
                </tr>
                {!plan.trial ? <tr>
                  <td>Next renewal</td>
                  <td>
                    {plan.next || '-'}
                  </td>
                  <td className={styles.td_cancel}>
                    {plan.next && <span className={styles.link}
                      onClick={
                        ()=>set_modal_cancel_features_by_gateway_type()}>
                      Cancel auto renewal
                    </span>}
                  </td>
                </tr> : <Fragment>
                  <tr>
                    <td>Next renewal</td>
                    <td>
                      <p className={cn(theme.p3, theme.reg, theme.color_n700)}>
                        {!cancelled ? 'You\'re on a 3-day free trial.'
                        : `Your free trial ends on ${plan?.grace_end}`}</p>
                    </td>
                  </tr>
                  {!cancelled && <Fragment>
                  <tr>
                    <td>&nbsp;</td>
                    <td>
                      <p className={cn(theme.p4, theme.reg, theme.color_n600)}>
                        {plan.name} plan starting {plan.next} at {amount}<br />
                        renewed every {format_plan(plan.name)} until cancelled
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>
                      <span className={styles.link}
                        onClick={()=>{ set_modal('cancel_trial'); }}>
                        Cancel free trial
                      </span>
                    </td>
                  </tr>
                  </Fragment>}
                </Fragment>}
              </tbody>
            </table>
          </div>
        </section>
        {/* {!!props.history.length && <section className={styles.section}>
          <h2 className={styles.section_title}>Payment method</h2>
          <div className={cn(styles.line, styles.payment_method)}>
            {history[0].method}
          </div>
        </section>} */}
        <section className={styles.section}>
          <p className={styles.contact_support}>
            If you have any payment or billing issues, please <Link
            to="/support/billing">contact support</Link>
          </p>
        </section>
      </Fragment>}
      <Modal is_open={modal=='cancel_features_apple'}
        on_close={()=>set_modal(null)} width={560}
        cls={styles.modal} no_logo>
          <div className={styles.cancel_features_apple_modal}>
            <Svg_appstore_modal />
            <div className={styles.cancel_apple_modal_text}>
              <p>Cancel your subscription on the App Store</p>
              <p>We're sorry to see you go.</p>
              <p>
                Your subscription plan is billed by Apple.
                To cancel, go to your Apple subscriptions
                and cancel it there. Your access continues
                until the current period ends.
              </p>
            </div>
            <div className={styles.cancel_apple_modal_buttons}>
              <Button caption="I understand, thanks"
                on_click={()=>set_modal(null)}/>
              <Button caption="OK, take me there"
                color="transparent"
                on_click={()=>{ window.open(
                  'https://account.apple.com/account/manage/section/subscriptions',
                  '_blank'); }}/>
            </div>
            <div className={styles.cancel_apple_modal_link}>
              <a href="https://support.apple.com/en-us/118428" target='_blank'
                rel='noopener noreferrer'>How to cancel with Apple</a>
            </div>
          </div>
        </Modal>
      <Modal is_open={modal=='cancel_features'} on_close={()=>set_modal(null)}
        width={760} cls={styles.modal} no_logo>
        <div className={styles.cancel_features}>
          <p className={cn(theme.bold, styles.p_title)}>
            Are you sure you want to cancel your
            subscription renewal?
          </p>
          <p className={cn(theme.p2, theme.med, styles.p_subtitle)}>
            You'll be letting go of a bunch of cool Hola Premium features
            at the end of your billing period
          </p>
          <Cancel_features_grid is_mobile={is_mobile}/>
          <div className={styles.buttons}>
            <Button caption="Stop auto renewal" color="white"
              size="md" on_click={
                ()=>{ set_modal(question ? 'cancel_help' : 'cancel_start'); }
              }/>
            <Button caption="Stay Premium" color="black2023" arrow
              size="md" on_click={()=>{ set_modal(null); }}/>
          </div>
        </div>
      </Modal>
      <Modal is_open={modal=='cancel_trial'} on_close={()=>set_modal(null)}
        width={400} cls={cn(styles.modal)} no_logo>
        <div className={styles.cancel_trial}>
          <div className={cn(theme.p1, theme.bold, theme.color_n700)}>
                Confirm cancellation</div>
          <p className={cn(theme.p3, theme.reg, theme.color_n600)}>
            If you end trial now,
            {' '}you will still have access to it until {plan?.grace_end}</p>
          <div className={styles.buttons}>
            <Button caption="Not now" color="white"
              on_click={()=>{ set_modal(null); }}/>
            <Button caption="Confirm" color="black2023" arrow
              size="md" on_click={()=>{ cancel(reason, answer); }}/>
          </div>
        </div>
      </Modal>
      <Modal is_open={modal=='cancel_help'}
        on_close={()=>set_modal(null)} no_close
        width={480} cls={styles.modal} no_logo>
        <Modal_header
          on_back={()=>set_modal('cancel_features')}
          on_close={()=>set_modal(null)}
        />
        <div className={styles.cancel_help}>
          <p className={cn(theme.bold, styles.p_title)}>
            Wait a tiny little second...
          </p>
          <p className={cn(theme.p2, styles.p_subtitle)}>
            {question?.text}
          </p>
            <div className={styles.links}>
              {question?.choices.map((value, idx)=>
                <Link key={value} to="#"
                  onClick={get_on_select_answer(idx)}
                >{value} {ic_right}</Link>
              )}
            </div>
          <button className={styles.skip}
            onClick={()=>{ set_modal('cancel_start'); }}>Skip</button>
        </div>
      </Modal>
      <Modal is_open={modal=='cancel_start'}
        on_close={()=>set_modal(null)} no_close
        width={480} cls={styles.modal} no_logo>
        <Modal_header
          on_back={()=>set_modal('cancel_help')}
          on_close={()=>set_modal(null)}
        />
        <div className={styles.cancel_start}>
          <Svg_cancel_start className={styles.bg}/>
          <p className={cn(theme.bold, styles.p_title)}>
            We will now start the process of canceling your Premium
            subscription.
          </p>
          <p className={cn(theme.p2, styles.p_subtitle)}>
            You will still be able to enjoy Hola Premium for the remainder
            of the period you've already paid for. Your subscription will
            then <span>not be renewed</span>.
          </p>
          <div className={styles.buttons}>
            <Button caption="Stop auto renewal" color="white"
              size="md" on_click={()=>{ set_modal('cancel_done'); }}/>
            <Button caption="Keep using Premium" color="black2023" arrow
              size="md" on_click={()=>{ set_modal(null); }}/>
          </div>
        </div>
      </Modal>
      <Modal is_open={modal=='cancel_done'}
        on_close={()=>set_modal(null)} no_close
        width={480} cls={styles.modal} no_logo>
        <Modal_header
          on_back={()=>set_modal('cancel_start')}
          on_close={()=>set_modal(null)}
        />
        <div className={styles.cancel_done}>
          <Svg_cancel_done className={styles.bg}/>
          <p className={cn(theme.bold, styles.p_title)}>
            Your Premium subscription will now no longer be renewed at the
            end of your billing period.
          </p>
          <p className={cn(theme.p2, styles.p_subtitle)}>
            Feel free to tell us why you're leaving Hola Premium so we can
            improve our offering.
          </p>
          <Textarea placeholder="Please specify" value={reason}
            on_change={v=>{ set_reason(v); }} cls={styles.comment}/>
          <Button caption="Done" color="black2023"
            size="md" on_click={()=>{ cancel(reason, answer); }}/>
        </div>
      </Modal>
    </div>;
};

const get_cc_icon = (t: string)=>{
    const v = t.toLowerCase();
    return /(amex|american)/.test(v) ? <Svg_amex/>
        : v.includes('discover') ? <Svg_discover/>
        : v.includes('master') ? <Svg_mastercard/>
        : v.includes('jcb') ? <Svg_jcb/> : <Svg_visa/>;
};

const get_payment_method = (v: string)=>{
    if (v.startsWith('paypal'))
        return 'Paypal';
    return v[0].toUpperCase() + v.slice(1);
};

const period2desc = {
    '3 Y': 'Hola Premium 3-Year',
    '1 Y': 'Hola Premium 1-Year',
    '1 M': 'Hola Premium 1-Month',
};
const period2sub_desc = {
    '3 Y': '3-Yearly subscription with 3 days free trial',
    '1 Y': 'Yearly subscription with 3 days free trial',
    '1 M': 'Monthly subscription with 3 days free trial',
};

type t_history_view_props = Pick<i_view_props, 'active' | 'toggle'>
  & {history: t_payment_item[]};

const Payment_history_view =
({active, toggle, history}: t_history_view_props)=>{
    const on_back = ()=>{
        toggle('plan');
    };
    return <div className={cn(styles.content, styles.history_view,
      styles.nested_content, active && styles.active)}>
      <h1 className={styles.title}>
        <button className={styles.back} onClick={on_back}>
          <Icon_chevron_left/> Back
        </button>
        My plan
      </h1>
      <section className={styles.section}>
        <h2 className={styles.section_title}>Payment history</h2>
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Payment <br/>Method</th>
              <th>Amount</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {history.map(d=>{
                return <tr key={d.timestamp}>
                  <td>{d.date}</td>
                  <td>{d.method}</td>
                  <td>{d.amount}</td>
                  <td>{d.desc}</td>
                </tr>;
            })}
          </tbody>
        </table>
        <p className={styles.contact_support}>
          If you have any payment or billing issues, please <Link
          to="/support/billing">contact support</Link>
        </p>
      </section>
    </div>;
};

type t_cp_premium_props = Pick<i_view_props,
  'premium' | 'back_btn' | 'is_mobile'>;

export const CP_premium = (props: t_cp_premium_props)=>{
    const history = use_payment_history();
    const [view, set_view] = useState('plan');
    const toggle = (to: string)=>{
        set_view(()=>{
            window.scrollTo(0, 0);
            return to;
        });
    };
    return <div className={cn(styles.cp_premium)}>
      <Plan_view {...props}
        active={view=='plan'} toggle={toggle} history={history}/>
      <Payment_history_view {...props}
        active={view=='history'} toggle={toggle} history={history}/>
    </div>;
};
